export default __webpack_public_path__ + "38e1ba2cc236a06f8a0f199865516065.png";